export default __webpack_public_path__ + "static/media/icon-profile.5f8186c5.svg";